interface IFlushResponse {
  ok: boolean;
  sentCount: number;
  errorMessage?: string;
}

export function requestServiceWorkerFlush(serviceWorker: ServiceWorker, routeKey: string, endpoint: string, timeoutMs: number = 15000): Promise<void> {
  return new Promise((resolve, reject) => {
    const channel = new MessageChannel();
    let settled = false;
    let timeoutId: number;

    const cleanup = (): void => {
      window.clearTimeout(timeoutId);
      channel.port1.onmessage = null;
      channel.port1.close();
    };

    timeoutId = window.setTimeout(() => {
      if (settled) {
        return;
      }

      settled = true;
      cleanup();
      reject(new Error(`Service worker flush timed out for ${routeKey}`));
    }, timeoutMs);

    channel.port1.onmessage = (event: MessageEvent<IFlushResponse>) => {
      if (settled) {
        return;
      }

      settled = true;
      cleanup();
      const response = event.data;
      if (response && response.ok) {
        resolve();
        return;
      }

      reject(new Error(response?.errorMessage || `Service worker flush failed for ${routeKey}`));
    };

    serviceWorker.postMessage(
      {
        type: 'FLUSH_REQUEST',
        routeKey,
        endpoint
      },
      [channel.port2]
    );
  });
}
